// react
import React from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
// material-ui
import { Card, CardActions } from "material-ui/Card"
import Dialog from "material-ui/Dialog"
import Divider from "material-ui/Divider"
import FlatButton from "material-ui/FlatButton"
// app
import { changePassword, deleteProfile, logout } from "actions/user/actions.js"
import UserDetails from "components/user/Details"


class Account extends React.Component {
    constructor(props) {
        super()

        this.state = {
            open: false
        }

        this.changePassword = (oldpwd, newpwd) => {
            this.props.changePassword(this.props.id, oldpwd, newpwd)
        }

        this.confirm = () => { this.setState({ open: true }) }
        this.cancel = () => { this.setState({ open: false }) }
        this.deleteProfile = () => {
            this.props.deleteProfile(this.props.id)
        }

        this.logout = () => {
            this.props.logout()
            location.href = "/"
        }
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={ true }
                onTouchTap={ this.cancel }
            />,
            <FlatButton
                label="Yes, Delete"
                secondary={ true }
                onTouchTap={ this.deleteProfile }
            />
        ]

        return (
            <DocumentTitle title="Account">
                <div className="page">
                    <div className="row">
                        <div className="col-xs-9">
                            <UserDetails
                                email={ this.props.email }
                                isAdmin={ this.props.isAdmin }
                                since={ this.props.since }
                                userName={ this.props.userName }
                                onSave={ this.changePassword }
                            />
                        </div>
                        <div className="col-xs-3">
                            <Card className="card">
                                <CardActions>
                                    <FlatButton
                                        label="Logout"
                                        onTouchTap={ this.logout }
                                        secondary={ true }
                                        style={{ width: "100%" }}
                                    />
                                    { this.props.isAdmin !== true ?
                                        <div>
                                            <Divider />
                                            <FlatButton
                                                label="Delete Profile"
                                                onTouchTap={ this.confirm }
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                    : null }
                                </CardActions>
                            </Card>
                        </div>
                    </div>
                    <Dialog
                        title="Please confirm your delete request"
                        actions={ actions }
                        modal={ true }
                        open={ this.state.open }
                    >
                        <div>
                            You are about to delete your profile.
                            This action cannot be undone.
                        </div>
                    </Dialog>
                </div>
            </DocumentTitle>
        )
    }
}

function mapStateToProps(state) {
    return {
        id: state.user.get("id"),
        isAdmin: (state.user.get("admin") === 1),
        email: state.user.get("email"),
        since: state.user.get("since"),
        userName: state.user.get("name")
    }
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        changePassword: (id, oldpwd, newpwd) => dispatch(changePassword(id, oldpwd, newpwd)),
        deleteProfile: (id) => dispatch(deleteProfile(id)),
        logout: () => dispatch(logout(ownProps.id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account)


/** WEBPACK FOOTER **
 ** ./src/containers/Account/account.js
 **/